module.exports = __webpack_public_path__ + "static/img/undraw_security_o890.3b56f46b.svg";